module.exports = __webpack_public_path__ + "static/media/boost-revenue-v1.f360d435.svg";